// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  participantId: __t.u64().primaryKey().name("participant_id"),
  conversationId: __t.u64().name("conversation_id"),
  userIdentity: __t.identity().name("user_identity"),
  role: __t.string(),
  joinedAt: __t.timestamp().name("joined_at"),
  isMuted: __t.bool().name("is_muted"),
  mutedUntil: __t.option(__t.timestamp()).name("muted_until"),
  lastReadMessageId: __t.option(__t.u64()).name("last_read_message_id"),
  isArchived: __t.bool().name("is_archived"),
  nickname: __t.option(__t.string()),
});
